import { upperCase as up } from '@/utils'

export default {
  'zh-CN': {
    name: '中文 (简体)',
    continent: 'Asia Pacific',

    // Text.
    noMatch: '无匹配数据',
    notFound: '列表为空',
    loading: '加载中',
    viewMore: '查看更多',

    // Errors messages.
    errors: {
      _default  : (field: any) => `${up(field)}的值无效`,
      alpha     : (field: any) => `${up(field)}只能包含字母字符`,
      alpha_num : (field: any) => `${up(field)}只能包含字母数字字符`,
      confirmed : (field: any, [confirmedField]: any) => `${up(field)}不能和${confirmedField}匹配`,
      email     : (field: any) => `${up(field)}不是一个有效的邮箱`,
      max       : (field: any, [length]: any) => `${up(field)}不能超过${length}个字符`,
      min       : (field: any, [length]: any) => `${up(field)}必须至少有${length}个字符`,
      required  : (field: any) => `${up(field)}是必须的`
    }
  }
}